import {
	Box,
	Button,
	Divider,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Autocomplete,
	Checkbox,
} from "@mui/material";
import DvrIcon from "@mui/icons-material/Dvr";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import React from "react";
import { durationList, sizes } from "../analyzeUtils";
import ActiveScenariosCheckbox from "./ActiveScenariosCheckbox";
import { useDispatch, useSelector } from "react-redux";
import {
	getChartDataForData,
	getScenariosData,
	getSkuPgData,
	setState,
	getCustomersData,
} from "../analyzeSlice";
import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";
import { setSelectProduct } from "../../Define/defineSlice";
import MultiSelectProducts from './MultiSelectProducts';
import MultiSelectCustomers from './MultiSelectCustomers';
import _ from "lodash";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function DataForm() {
	const [countryData, setCountryData] = useState("");
	const [scenarioData, setScenarioData] = useState("");

	const [alert, setAlert] = useState({
		alertSeverity: "",
		alertDisplay: false,
		alertMessage: ""
	});

	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	const loginState = useSelector((store) => store.login);
	const {
		countries,
		selectedCountry,
		selectedCountryID,

		isActiveScenario,

		selectedAnalysisTypeID,

		scenariosData,
		selectedScenarioName,
		selectedScenarioID,

		skuPgsData,
		selectedSkuPgName,
		selectedSkuPgID,
		customersData,

		duration,
		selectedDataCustomerIds,
		customerList,
		selectedDataProductIds,
		allCustomersSelected,
	} = state;

	const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
	const checkedIcon = <CheckBoxIcon fontSize="small" />;

	useEffect(() => {
		dispatch(setState("selectedCountry", ""));
		// dispatch(setState("selectedCountryID", "null"));

		dispatch(setState("selectedScenarioName", ""));
		// dispatch(setState("selectedScenarioID", null));
		dispatch(setState("selectedDataCustomerIds", []));
		dispatch(setState("customerList", []));
		dispatch(setState("selectedDataProductIds", []));
		dispatch(setState("clearDataValues", true));
		dispatch(setState("duration", null));
		dispatch(setState("clearAnalyzeData", false));

		dispatch(setState("scenariosData", []));
		dispatch(setState("skuPgsData", []));
		dispatch(setState("customersData", []));

		}, [])

	const clearValues = () => {
		dispatch(setState("clearDataValues", true));
		dispatch(setState("selectedDataCustomerIds", []));
		dispatch(setState("customerList", []));
		dispatch(setState("selectedDataProductIds", []));
	}


	useEffect(() => {
		if (countryData !== "") {
			getScenariosForCountry();
		}
	}, [countryData]);

	useEffect(() => {
		if (scenarioData !== "") {
			getSkuPgForScenario();
		}
	}, [scenarioData]);



	function setCountry(event) {
		const name = event.target.value;
		const countryID = countries.find(
			(country) => country.countryName === name
		).countryID;

		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", countryID));
		dispatch(setState("selectedScenarioName", ""));

		setCountryData(name);
		clearValues();
		dispatch(setState("clearAnalyzeData", false));
	}

	function getScenariosForCountry() {
		const countryID = selectedCountryID;
		const activeScenario = isActiveScenario;
		const analyisID = selectedAnalysisTypeID;
		const obj = {
			countryID,
			activeScenario,
			analyisID,
		};
		dispatch(getScenariosData(obj));
	}

	function setScenario(event) {
		const id = event.target.value;
		const name = scenariosData?.find(
			(scenario) => scenario.scenarioID === id
		).scenarioName;
		dispatch(setState("selectedScenarioName", name));
		dispatch(setState("selectedScenarioID", id));

		setScenarioData(id);

		clearValues();
		dispatch(setState("clearAnalyzeData", false));
	}

	function getSkuPgForScenario() {
		const scenarioID = selectedScenarioID;
		const obj = {
			scenarioID,
		};
		dispatch(getSkuPgData(obj));
		dispatch(getCustomersData(obj));
	}

	function setSkuPg(event) {
		const name = event.target.value;
		const id = skuPgsData.find(
			(skuPg) => skuPg?.packGroupOrSKUName === name
		).packGroupOrSKUID;
		dispatch(setState("selectedSkuPgName", name));
		dispatch(setState("selectedSkuPgID", id));
	}

	function setDuration(event) {
		const d = event.target.value;
		dispatch(setState("duration", d));
	}

	// useEffect(() => {
	// 	//Check if any of the dropdown are false and then set alertDisplay to false
	// 	const isAnyKeyValueFalse = o => !!Object.keys(o).find(k => !o[k]);

	// 	if (isAnyKeyValueFalse(validate)) {
	// 		setAlert({ ...Alert, alertDisplay: false });
	// 	}
	// }, [validate])


	const displayAlert = (severityType) => {
		setAlert({
			"alertSeverity": "warning",
			"alertDisplay": true,
			"alertMessage": `Please select the ${severityType}`
		});

		setTimeout(() => {
			clearAlert();
		},[2000])
		
	}

	const clearAlert = () => {
		setAlert({
			"alertSeverity": "",
			"alertDisplay": false,
			"alertMessage": ``
		});
	}
	const getCustomerIdsFromNames = (customerNames) => {
		// const customerIds = customerNames.map((name) => {
		//   const customer = customersData.find((option) => option.customerName === name);
		//   return customer ? customer.customerID : null;
		// });
		// return customerIds.filter((id) => id !== null);

		const uniqueKeys = new Map();
		for (const item of customersData) {
			const key = `${item.customerName}`;
			uniqueKeys.set(key, item.customerID);
		}
		
		const customerIds = [];
		
		for (const item of customerNames) {
			const key = `${item}`;
			if (uniqueKeys.has(key)) {
				customerIds.push(uniqueKeys.get(key));
			} else {
				customerIds.push(item);
			}
		}
		return customerIds.filter((id) => id !== null);

	};

	const handleDisplay = () => {
		if (selectedCountry === null || selectedCountry === "") {
			displayAlert("Country");
			return;
		}
		if (selectedScenarioName === null || selectedScenarioName === "") {
			displayAlert("Scenario");
			return;
		}
		if (selectedDataProductIds.length === 0) {
			displayAlert("SKU / PG");
			return;
		}
		if (customerList.length === 0) {
			displayAlert("Customer");
			return;
		}
		if (duration === null || duration === "") {
			displayAlert("Duration");
			return;
		}
		dispatch(setState("isLoading", true));
		const timer = setTimeout(() => {
		let ids = [];
		if(allCustomersSelected){
			ids = [];
		}else{
			if (customerList.length > 0) {
				ids = getCustomerIdsFromNames(customerList);
				//dispatch(setState("clearDataValues", false));
			}
			else {
				ids = [];
			}
		}
		dispatch(setState("selectedDataCustomerIds", ids));
		const scenarioID = selectedScenarioID;
		const skuPgID = selectedSkuPgID;
		const obj = {
			customerIds: ids,
			duration: duration,
			isAllCustomerSelected: allCustomersSelected,
			productIds: selectedDataProductIds,
			scenarioID: selectedScenarioID,
		};

		//Alert if any of the dropdowns are not validated
			dispatch(setState("clearAnalyzeData", true));
		
			dispatch(getChartDataForData(obj));
		//dispatch(getChartDataForData(obj));
	},10);
	}

	return (
		<Box sx={{ mt: 3 }}>
			<Grid container
				// columns={12} spacing={3} 
				columnGap={3} rowGap={3}
				alignContent={"space-between"}>
				<Grid item sm={6} md={4} lg={1.8}>
					<FormControl >
						<InputLabel>Country</InputLabel>
						<Select
							value={countryData}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setCountry}
						>
							{countries.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item
				 sm={6} md={4} lg={1.8}
				>
					<FormControl>
						<InputLabel>Scenario</InputLabel>
						<Select
							value={scenarioData}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setScenario}
						>
							{scenariosData?.map((scenario, index) => {
								return (
									<MenuItem key={index} value={scenario.scenarioID}>
										{scenario.scenarioName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item
				// sm={6} md={4} lg={1.5}
				>
					<MultiSelectProducts skuPgs={skuPgsData} />
				</Grid>

				<Grid item
				// sm={6} md={4} lg={1.5}
				>
					<MultiSelectCustomers customers={customersData} />
				</Grid>

				<Grid item
				 sm={6} md={4} lg={1.8}
				>
					<FormControl>
						<InputLabel>Duration</InputLabel>
						<Select
							value={duration}
							label="Duration"
							sx={{
								height: selectHeight,
								color: "black.main",
								mt: 1,
							}}
							onChange={setDuration}
						>
							{durationList.map((duration, index) => {
								return (
									<MenuItem key={index} value={duration.value}>
										{duration.label}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item
				// sm={6} md={4} lg={2}
				>
					<ActiveScenariosCheckbox />
				</Grid>
				<Grid item
				// sm={6} md={4} lg={1}
				>
					<Button
						startIcon={<DvrIcon />}
						sx={{
							bgcolor: "blue.main",
							color: "white.main",
							textTransform: "none",
							fontWeight: "bold",
							"&:hover": {
								bgcolor: "skyBlue.main",
								color: "black.main",
							},
						}}
						onClick={() => handleDisplay()}
					>
						Display
					</Button>
				</Grid>
			</Grid>
			{alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}
			<Divider sx={{ mt: 3 }} />
		</Box>
	);
}